import React, {useEffect} from 'react'
import {IconButton, InputAdornment, ListItem, ListItemSecondaryAction, ListItemText, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import positionsItems, {POSITION_VALUE} from 'constants/PositionItems'
import pgPositionsItems from 'constants/PurchasingGroupPositionItems'
import GridBlock from 'components/GridBlock';
import Select from 'components/Select';
import getObjectValue from 'libs/getObjectValue';
import TextInput from 'components/TextInput';
import CloseIcon from '@material-ui/icons/Close'
import removeFormikListElement from 'libs/removeFormikListElement';
import Tr from 'translations/Translations';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import CommissionUserType from "constants/CommissionUserType";
import {connect} from "react-redux";

const style = theme => ({
    root: {
        paddingRight: theme.spacing(2),
    },
    primaryAction: {
        width: "calc(100% - 260px)",
    },
    secondaryAction: {
        width: 250,
    },
    iconButton: {
        padding: theme.spacing(1) / 2,
    },
    grid: {
        '&>*:first-child': {
            flexGrow: 1
        }
    },
    email: {
        fontStyle: 'italic',
        fontWeight: theme.typography.fontWeightBold,
        fontSize: '0.75rem'
    }
})

function FullNamePositionItem(
    {
        classes,
        formikProps,
        index,
        id,
        item,
        purchasingGroupHeader
    }) {
    const selectTextId = `${id}.${index}.otherRole`
    const otherValue = getObjectValue(selectTextId, formikProps.values, "");

    useEffect(() => {
        if (role === POSITION_VALUE.OTHER) formikProps.setFieldValue(selectTextId, otherValue)
        // eslint-disable-next-line
    }, [role])

    const selectId = `${id}.${index}.role`
    const otherRole = `${id}.${index}.otherRole`
    const role = getObjectValue(selectId, formikProps.values);
    const editable = getObjectValue('_editable', formikProps.values, true);

    const closeTextInput = () => {
        formikProps.setFieldValue(selectId, POSITION_VALUE.CHAIRMAN)
        formikProps.setFieldValue(otherRole, undefined)
    }

    const handleDelete = () => {
        removeFormikListElement(formikProps, id, index)
    }
    const externalUser = item.userType === CommissionUserType.EXTERNAL_USER;
    const getPrimaryText = () => (<>
        <Typography variant='body2' component='span'>{item.firstName} {item.lastName}</Typography>
        {externalUser &&
        <Typography variant='body2' component='span' className={classes.email}>{' (' + (item.email ? item.email : Tr('email_empty')) + ')'}</Typography>}
    </>)

    const secondaryText = externalUser ? Tr('external') : item.organizationName;

    return (
        <ListItem role="listitem" className={classes.root}>
            <ListItemText classes={{primary: classes.primaryAction, secondary: classes.primaryAction}} primary={getPrimaryText()} secondary={secondaryText}/>
            <ListItemSecondaryAction className={classes.secondaryAction}>
                <GridBlock
                    wrap='nowrap'
                    justify='space-between'
                    className={classes.grid}
                >
                    {role === POSITION_VALUE.OTHER ?
                        <TextInput
                            id={selectTextId}
                            formikProps={formikProps}
                            // noError
                            endAdornment={
                                <InputAdornment position='end'>
                                    <IconButton
                                        onClick={closeTextInput}
                                        className={classes.iconButton}
                                        disabled={!editable}
                                    >
                                        <CloseIcon/>
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        :
                        <Select
                            id={selectId}
                            formikProps={formikProps}
                            items={!purchasingGroupHeader ? positionsItems : pgPositionsItems}
                            noError
                        />
                    }
                    <WorkableIconDeleteButton
                        className={classes.iconButton}
                        onClick={handleDelete}
                        disabled={!editable}
                    />
                </GridBlock>
            </ListItemSecondaryAction>
        </ListItem>
    )
}

FullNamePositionItem.propTypes = {
    classes: PropTypes.any,
    name: PropTypes.string,
}

FullNamePositionItem.defaultProps = {}

export default connect((state) => ({
    purchasingGroupHeader: state.resources.purchasingGroupHeader
}), {

})(withStyles(style)(FullNamePositionItem));